import React from 'react';
import { FormattedMessage } from 'react-intl';

import SectionMessage from '@atlaskit/section-message/message';

import { i18n } from '../i18nPagePropertiesReport.ts';

export const ErrorState = (): React.JSX.Element => {
	return (
		<SectionMessage appearance="error">
			<FormattedMessage {...i18n.errorMessage} />
		</SectionMessage>
	);
};
